/* src/app/pages/ui-kit/components/editor-view/editor-view.component.scss */
.box {
  max-width: 900px;
}
/*# sourceMappingURL=editor-view.component.css.map */
